import { createContext, useReducer, useEffect } from "react";
import { THEME_COLORS } from "../constants/CommonConstants";
import { useSelector } from "react-redux";
import { FLAG_CONSTANTS } from "../constants/flagConstants";

export const ThemeContext = createContext();

const ThemesReducer = (state, action) => {
  switch (action.type) {
    case "LIGHT":
      return { ...state, themeChange: THEME_COLORS.LIGHT };
    case "DARK":
      return { ...state, themeChange: THEME_COLORS.DARK };
    case "DEFAULT":
      return { ...state, themeChange: THEME_COLORS.DEFAULT };
    default:
      return state;
  }
};

export const ThemeContextProvider = ({ children }) => {
  const role = localStorage.getItem("role");
  const isSuperAdmin = role === FLAG_CONSTANTS.SUPER_ADMIN_FLAG;

  const { defaultWorkspaceTheme } = useSelector(
    (state) => state?.GetWorkspaceListReducer?.user || {},
  );

  const [state, dispatch] = useReducer(ThemesReducer, undefined, () => ({
    themeChange: isSuperAdmin
      ? THEME_COLORS.DARK
      : defaultWorkspaceTheme || THEME_COLORS.DEFAULT,
  }));

  useEffect(() => {
    if (isSuperAdmin) {
      dispatch({ type: "DARK" });
    } else if (defaultWorkspaceTheme) {
      dispatch({ type: defaultWorkspaceTheme.toUpperCase() || "DEFAULT" });
    }
  }, [defaultWorkspaceTheme, isSuperAdmin]);

  return (
    <ThemeContext.Provider value={{ ...state, dispatch }}>
      {children}
    </ThemeContext.Provider>
  );
};
